<template>
	<div class="container">
		<div class="row">

			<div class="col-lg-7 col-md-7 col-12">
				<div class="logo_">
					<router-link to="/">
						<img class="w-100" src="@/assets/store/home/svglogo.svg" alt="">
					</router-link>
				</div>

				<div v-if="order" class="color-blue font-general-r">
					<span class="h5">Pedido #{{ order.code }}</span> <br>
					<span v-if="order.quick_purchase" class="h3">
						Gracias {{ order.data_address.name }}!
					</span>
					<span v-else class="h3">Gracias {{ order.user.name }}!</span> <br>
          <v-btn
            color="accent"
            class="nv-btn nv-btn-medium mr-8"
            elevation="0"
            :loading="loading_btn"
            @click="getOrder(false)"
          >
            REFRESCAR
          </v-btn>

					<v-card
						class="mt-5"
						max-width="600"
					>
						<GoogleMap :center="center" title="Ubicación"></GoogleMap>

						<v-card-title>
							{{ message }}

              <p>{{ formatedAddressUbication }}</p>

						</v-card-title>

						<v-card-subtitle>
							Vuelve a esta página para recibir actualizaciones sobre el estado de tu envío.
						</v-card-subtitle>

					</v-card>

					<v-card
						class="mt-5"
						max-width="600"
					>
						<v-card-text>
							<div class="row">
								<div class="col">
									<p class="h5 color-blue">
										Información del cliente
									</p>

									<p class="h6 color-blue font-weight-bold">Información de contacto</p>
									<p class="h6 color-blue">
										{{ order.quick_purchase ? order.contact_email : order.user.email }}
									</p>

									<p class="h6 color-blue font-weight-bold">
										Dirección de envío
									</p>
									<span class="h6 color-blue">
										{{
											order.quick_purchase ?
												`${order.data_address.name} ${order.data_address.lastname}` :
												order.user.full_name
										}}
									</span><br>
									<span class="h6 color-blue">
										{{
											order.quick_purchase ?
												`${order.data_address.name} ${order.data_address.lastname}` :
												order.address.full_address
										}}
									</span><br>
									<span class="h6 color-blue">
										{{
											order.quick_purchase ?
												order.data_address.phone :
												order.user.phone
										}}
									</span>

								</div>
								<div class="col">
									<p class="mt-10 h6 color-blue font-weight-bold">
										Método de envío
									</p>
									<p class="h6 color-blue">
										{{ order.delivery_method == 'free' ? 'Recoger en tienda' : 'CDMX' }}
									</p>

									<p class="h6 color-blue font-weight-bold">
										Métodos de pago
									</p>
									<div class="color-blue d-flex">

										<p class="h6">{{ currencyFormat(order.total) }}</p>
									</div>
								</div>
							</div>

						</v-card-text>
					</v-card>

					<div class="mt-10">
						<p class="h6">
							¿Necesitas ayuda?
							<a href="mailto:hola@nievedeolla.com">Ponte en contacto con nosotros</a>
						</p>
						<div class="text-right">
							<v-btn
								to="/"
								color="accent"
								class="nv-btn nv-btn-large mr-8"
								elevation="0"
							>
								VOLVER A LA TIENDA
							</v-btn>
						</div>
					</div>

				</div>
			</div>

			<div class="col-lg-5 col-md-5 col-12" style="padding-top: 0 !important">
				<div v-if="order" class="container-cart-payment cart-payment color-blue font-general-r">
					<simplebar style="max-height: 420px;">
						<div class="row pb-5" v-for="(item, index) of order.details" :key="index">
							<div class="col">
								<v-badge
									right
									:content="`${item.quantity}`"
									color="accent"
									offset-x="10"
									offset-y="10"
								>
									<img
										:src="item.flavor.url_image_detail"
										:alt="item.flavor.name"
										class="img-product-cart-payment"
									/>
								</v-badge>
							</div>
							<div class="col d-flex align-items-center justify-content-start">
								<span>
									<p class="h5">{{ item.flavor.name.toUpperCase() }}</p>
									<p v-if="item.variant" class="h6">{{ item.variant.toUpperCase() }}</p>
								</span>
							</div>
							<div class="col d-flex align-items-center">
								<p :class="`h3 font-general-r ${item.discount ? 'price-discount text-danger' : '' }`">
									{{ currencyFormat(item.subtotal) }}
								</p>
							</div>
						</div>
					</simplebar>
					<div class="border-blue"></div>
					<div class="row pt-5">
						<div class="col">
							<div class="d-flex align-items-center justify-content-between">
								<p>SUBTOTAL</p>
								<p>{{ currencyFormat(order.subtotal) }}</p>
							</div>
							<div class="d-flex align-items-center justify-content-between">
								<p>ENVÍOS</p>
								<p>
									{{ currencyFormat(order.shipping_amount) }}
								</p>
							</div>
						</div>
					</div>
					<div class="border-blue"></div>
					<div class="row pt-5 pb-5">
						<div class="col d-flex align-items-center justify-content-between">
							<p>TOTAL</p>
							<p class="h4">
								{{ currencyFormat(order.total) }}
							</p>
						</div>
					</div>
				</div>
			</div>

		</div>

    <v-overlay :value="overlay">
      <img class="nv-loading" src="@/assets/store/nievedeolla.gif" alt="">
    </v-overlay>

	</div>
</template>

<script>
import UserService from '@/services/user.service'
import { currencyFormat } from '@/helpers'
import simplebar from 'simplebar-vue';
import 'simplebar/dist/simplebar.min.css';
import GoogleMap from '@/components/store/GoogleMap'

export default {
	components: { simplebar, GoogleMap },
	data() {
		return {
      order: null,
      google: null,
      map: null,
      center: {
        lat: 0,
        lng: 0,
      },

      overlay: false,
      loading_btn: false,
      message: '',
      status: ['ASSIGNING_DRIVER', 'ON_GOING', 'CANCELED', 'PICKED_UP', 'REJECTED', 'COMPLETED', 'EXPIRED'],
      formatedAddressUbication: ''
    }
	},
	methods: {
    getStatusOrder(status) {
      if (status == 1) return 'Tu pedido esta en espera de confirmación'
			if (status == 2) return 'Tu pedido ha sido confirmado'
			if (status == 3) return 'Tu pedido ya esta preparado'
      if (status == 4) return 'Tu pedido ha sido enviado a tu ubicación'
      if (status == 5) return '¡Pedido entregado, que lo disfrutes!'
      if (status == 6) return 'El pedido ha sido cancelado'
    },
		async getOrder(loading = true) {
			try {
        if (loading) this.overlay = true

        this.loading_btn = true
        let params

        if (this.$route.params.user_id) {
          params = {
            order_id: this.$route.params.order_id,
            user_id: this.$route.params.user_id
          }
        } else {
          params = {
            order_id: this.$route.params.order_id,
            user_id: ''
          }
        }

        const { data:res } = await UserService.getOrder(params.order_id, params.user_id)

				if (res.success) {
					this.order = res.data

          if (this.order.lalamove_id) {
            const { data:res } = await UserService.getOrderLalamove(this.order.lalamove_id)
            if (res.success) {

              if (!res.data.clientError) {

                const statusLalamove = res.data.response.status

                if (res.data.response.driverId) {

                  console.log(res.data)

                  const { data:res } = await UserService.getDriverUbication(
                    this.order.lalamove_id,
                    res.data.response.driverId
                  )
                  if (!res.data.clientError) {
                    //mensaje para el cuadro del mapa
                    this.message = this.getStatusLalamove(statusLalamove)
                    this.center.lat = parseFloat(res.data.response.location.lat)
                    this.center.lng = parseFloat(res.data.response.location.lng)
                    this.geocoder(this.center.lat, this.center.lng)
                  } else {
                    //mensaje para el cuadro del mapa
                    this.message = this.getStatusOrder(this.order.status)
                    this.setMap()
                  }
                } else {
                  this.message = this.getStatusLalamove(statusLalamove)
                  this.setMap()
                }
              } else {
                //mensaje para el cuadro del mapa
                this.message = this.getStatusOrder(this.order.status)
                this.setMap()
              }
            } else {
              this.$swal(res.error, '', 'warning')
            }

          } else {
            this.message = this.getStatusOrder(this.order.status)
            this.setMap()
          }

				} else {
          console.log(res)
					this.$swal(res.error, '', 'warning')
				}

        this.overlay = false
        this.loading_btn = false

			} catch(e) {
        console.log(e)
        this.overlay = false
        this.loading_btn = false
				this.$swal('En estos momentos no estamos disponibles, intenta más tarde', '', 'warning')
			}
		},
    getStatusLalamove(status) {
      if (status == 'ASSIGNING_DRIVER') return 'Estamos asignando un repartidor para tu pedido'
			if (status == 'ON_GOING') return 'Tu pedido se encuentra en camino'
			if (status == 'CANCELED') return 'Tu pedido esta cancelado'
      if (status == 'PICKED_UP') return 'Tu pedido esta a punto de salir a destino'
      if (status == 'REJECTED') return 'Tu pedido ha sido rechazado'
      if (status == 'COMPLETED') return 'Tu pedido ha sido entregado. ¡Qué lo disfrutes!'
      if (status == 'EXPIRED') return 'Tu pedido ha expirado'
    },
    geocoder(lat, lng) {
      const geocoder = new window.google.maps.Geocoder;

      let latlng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng),
      };

      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            this.formatedAddressUbication = results[0].formatted_address
          } else {
            this.formatedAddressUbication = 'No se pudo obtener la dirección sobre las coordenadas en las que se encuentra el repartidor'
          }
        } else {
          this.formatedAddressUbication = 'No se pudo obtener la dirección sobre las coordenadas en las que se encuentra el repartidor'
        }
      })
    },
    setMap() {
      if (this.order.quick_purchase) {
        this.center.lat = parseFloat(this.order.data_address.latitude)
        this.center.lng = parseFloat(this.order.data_address.longitude)
      } else {
        this.center.lat = parseFloat(this.order.address.latitude)
        this.center.lng = parseFloat(this.order.address.longitude)
      }
      this.geocoder(this.center.lat, this.center.lng)
      console.log(this.center)
    },
		currencyFormat(amount) {
			return currencyFormat(amount)
		}
	},
	created() {
		this.getOrder()
	}
}
</script>

<style scoped>
	@import '../assets/css/styles.css';
	.logo_ {
		width: 250px;
		padding: 40px 0 50px 0
	}
	>>>.v-badge__badge {
		font-family: var(--font-baloo-regular) !important;
	}
	.container-cart-payment {
		width: 100%;
		height: 100%;
	}
	.cart-payment {
		height: 100%;
		background-color: var(--color-light);
		padding: 2em;
		width: 100%;
	}
	>>>.simplebar-scrollbar::before {
		background-color : var(--color-secondary);
	}
	.border-blue {
		background: var(--color-tertiary);
		height: 2px;
	}
</style>
